export const useGtag = () => {
    const isProd = process.env.REACT_APP_STRIPE_PUBLIC_KEY.indexOf('pk_live') === 0
    const gtagCheckout = (data) => {
        if (isProd && window && window.gtag) {
            const { items, subtotal, discounts } = data
            const cartItems = items.map((item) => {
                return {
                    item_id: item?.id,
                    item_name: item?.title,
                    price: item?.unit_price / 100,
                    quantity: item?.quantity,
                    discount: item?.discount_total ? item?.discount_total / 100 : 0,
                    coupon: discounts && discounts?.length > 0 ? discounts[0]?.code : ''
                }
            })
            try {
                window.gtag('event', 'begin_checkout', {
                    currency: 'USD',
                    value: subtotal / 100,
                    items: cartItems
                })
            } catch (err) {
                console.error(err)
            }
        }
    }

    const gtagBooking = (data) => {
        if (isProd && window && window.gtag) {
            try {
                const { items, subtotal, discounts, shipping_total, payments } = data
                const cartItems = items.map((item) => {
                    return {
                        item_id: item?.id,
                        item_name: item?.title,
                        price: item?.unit_price / 100,
                        quantity: item?.quantity,
                        discount: item?.discount_total ? item?.discount_total / 100 : 0,
                        coupon: discounts && discounts?.length > 0 ? discounts[0]?.code : ''
                    }
                })

                    window.gtag('event', 'purchase', {
                    currency: 'USD',
                    value: subtotal / 100,
                    coupon: discounts && discounts?.length > 0 ? discounts[0]?.code : '',
                    shipping: shipping_total ? shipping_total / 100 : 0,
                    items: cartItems,
                    transaction_id: payments[0]?.id || ''
                })
            } catch (err) {
                console.error(err)
            }
        }
    }


    const gtagAddToCart = (subtotal, product) => {
        if (isProd && window && window.gtag) {
            const items = [
                {
                    id: product?.id,
                    title: product?.title,
                    unit_price: product?.variants[0]?.prices[0]?.amount,
                    quantity: 1
                }
            ]
            try {
                window.gtag('event', 'add_to_cart', {
                    currency: 'USD',
                    value: subtotal / 100,
                    items: items
                })
            } catch (err) {
                console.error(err)
            }
        }
    }

    const gtagViewCart = (subtotal, product) => {
        if (isProd && window && window.gtag) {
            const items = [
                {
                    id: product?.variant?.product_id,
                    title: product?.title,
                    unit_price: product?.unit_price,
                    quantity: product?.quantity
                }
            ]
            try {
                window.gtag('event', 'view_cart', {
                    currency: 'USD',
                    value: subtotal / 100,
                    items: items
                })
            } catch (err) {
                console.error(err)
            }
        }
    }

    const gtagRemoveFromCart = (subtotal, product) => {
        if (isProd && window && window.gtag) {
            const items = [
                {
                    id: product?.variant?.product_id,
                    title: product?.title,
                    unit_price: product?.unit_price,
                    quantity: product?.quantity
                }
            ]
            try {
                window.gtag('event', 'view_cart', {
                    currency: 'USD',
                    value: subtotal / 100,
                    items: items
                })
            } catch (err) {
                console.error(err)
            }
        }
    }
    

    const gtagViewDownloadEvent = (eventName, data) => {
        if(isProd && window && window.gtag) {
            try {
                window.gtag('event', eventName, data);
            } catch (err) {
                console.error(err)
            }
        }
    }

    return {
        gtagCheckout,
        gtagBooking,
        gtagAddToCart,
        gtagViewCart,
        gtagRemoveFromCart,
        gtagViewDownloadEvent
    }
}
